:host {
  position: absolute;
  --info-card-background-color: var(--blue-layout-403-primary);
  --info-card-width: 320px;
}

.info-card-container {
  position: relative;
  z-index: 1;
  background-color: var(--info-card-background-color);
  width: var(--info-card-width);
  display: flex;
  flex-direction: column;
  padding: calc(var(--spacer) * 2) calc(var(--spacer) * 3) calc(var(--spacer) * 4) calc(var(--spacer) * 3);
  border-radius: calc(var(--spacer) * 0.5);
  box-sizing: border-box;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: var(--white-layout-101-outline-on-dark-background);
}

.close-button-container {
  display: flex;
  justify-content: flex-end;

  .close-button {
    height: calc(var(--spacer) * 3);
    margin-right: calc(var(--spacer) * -1);
  }
}

.header-title-container {
  display: flex;
  flex-direction: column;
  margin-bottom: calc(var(--spacer) * 2);

  .header-title {
    line-height: 30px;
  }
}

.image-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; // 16:9 aspect ratio (100% / 16 * 9)
  margin-bottom: calc(var(--spacer) * 3);

  .image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.body-title-container {
  margin-bottom: calc(var(--spacer) * 2);

  .body-title {
    text-transform: uppercase;
    line-height: 27px;
  }
}

.description-container {
  .description {
    line-height: 20px;

    &:not(:last-child) {
      margin-bottom: calc(var(--spacer) * 3);
    }
  }
}

.buttons-container {
  display: flex;
  flex-direction: column;
  gap: var(--spacer);
  margin-top: calc(var(--spacer) * 3);
}

.footer-container {
  margin-top: calc(var(--spacer) * 3);

  .navigation-container {
    margin-top: var(--spacer);
    height: calc(var(--spacer) * 3);
    display: flex;
    justify-content: space-between;

    .previous-button {
      rotate: 180deg;
    }

    .bullets-container {
      margin-left: var(--spacer);
      display: flex;
      align-items: center;
      gap: calc(var(--spacer) * 0.5);

      .bullet {
        border: 1px solid var(--white-layout-300-primary);
        border-radius: 50%;
        height: calc(var(--spacer) - 2px);
        width: calc(var(--spacer) - 2px);

        &.current {
          background-color: var(--white-layout-300-primary);
        }
      }
    }

    .next-button {
      --button-font-size: 12px;
      --button-height: calc(var(--spacer) * 3);
      margin-right: calc(var(--spacer) * -1);

      .button-text {
        margin-left: calc(var(--spacer) * -0.5);
      }

      .button-icon {
        margin-right: calc(var(--spacer) * -1.5);
      }
    }
  }

  .footer-title-container {
    margin-top: var(--spacer);
    margin-left: auto;
    width: fit-content;
    min-height: calc(var(--spacer) * 3);

    .footer-title {
      line-height: 18px;
      width: fit-content;
    }
  }
}

.header-title,
.body-title,
.description,
.footer-title {
  --font-family: var(--font-family-secondary);
  color: var(--white-layout-300-primary);
}

.close-button,
.previous-button {
  // override colors to match the DS
  --body-text-arrows-400: transparent; // default
  --chart-300-icon-buttons: var(--white-layout-010-hover-primary); // hover
  --chart-300-icon-buttons: var(--blue-layout-501-focus); // focus
}

.card-pointer {
  position: absolute;
  top: 0;
  width: 18px;
  height: 12px;
  background-color: var(--info-card-background-color);
  clip-path: polygon(0 0, 100% 0, 50% 100%);
}
